import { BASE_URL } from "../environment";
const baseUrl = BASE_URL;
const users = "users/";
const listings = "listings/";
const tags = "tags/";
const announcements = "announcements/";
const tickets = "tickets/";
const trades = "trades/";
const support = "support/";
const checklist = "checklist/";
export const api = {
  auth: {
    get loginUrl() {
      return `${baseUrl}${users}login`;
    },
    get signupUrl() {
      return `${baseUrl}${users}signup`;
    },
    get googleLoginUrl() {
      return `${baseUrl}${users}googleLogin`;
    },
    get googleSignupUrl() {
      return `${baseUrl}${users}googleSignup`;
    },
    get verifyEmailUrl() {
      return `${baseUrl}${users}verifyEmail`;
    },
    get resendLinkUrl() {
      return `${baseUrl}${users}resendLink`;
    },
    get resendVerificationByEmailUrl() {
      return `${baseUrl}${users}resendVerificationByEmail`;
    },
    get isEmailTaken() {
      return `${baseUrl}${users}check/email`;
    },
    get isEmailTakenTradesperson() {
      return `${baseUrl}${users}check/email-tradesperson`;
    },
    get forgotPasswordUrl() {
      return `${baseUrl}${users}forgotPassword`;
    },
    get verifyResetPassUrl() {
      return `${baseUrl}${users}verifyResetPass`;
    },
    get resetPassUrl() {
      return `${baseUrl}${users}resetPass`;
    },
    getLandlordTenants(lisitngId) {
      return `${baseUrl}${users}myTenants/${lisitngId}`;
    }
  },
  dashboard: {
    get tenantDashboard() {
      return `${baseUrl}tenantDashboard`;
    },
    get analytics() {
      return `${baseUrl}analytics`;
    },
    get updateActivityView() {
      return `${baseUrl}analytics/updateActivityView`;
    }
  },
  lisitng: {
    get addListingUrl() {
      return `${baseUrl}${listings}add`;
    },
    deleteListingUrl(listingId) {
      return `${baseUrl}${listings}delete/${listingId}`;
    },
    get getListingsUrl() {
      return `${baseUrl}${listings}all`;
    },
    get getListingsStatsUrl() {
      return `${baseUrl}${listings}stats`;
    },
    get getListingsExternalPortal() {
      return `${baseUrl}${listings}allExternal`;
    },
    get getTenantListingsUrl() {
      return `${baseUrl}${listings}assignedListing`;
    },
    getListingDetailsUrl(listingId) {
      return `${baseUrl}${listings}details/${listingId}`;
    },
    updateListingNotes(listingId) {
      return `${baseUrl}${listings}${listingId}/notes`;
    },
    getListingNotes(listingId) {
      return `${baseUrl}${listings}notes/${listingId}`;
    },
    get assignTenantByLandlordUrl() {
      return `${baseUrl}${listings}assignLandlord`;
    },
    get massInsertTenantTemplate() {
      return `${baseUrl}${listings}mass-insert-tenant/template`;
    },
    get massUploadTenant() {
      return `${baseUrl}${listings}mass-insert-tenant/upload`;
    },
    get sendCreateAccountReminderUrl() {
      return `${baseUrl}${listings}create-account/reminders`;
    },
    get updateTenantEmailUrl() {
      return `${baseUrl}${listings}update/tenant-email`;
    },
    get deleteTenantsFromProperty() {
      return `${baseUrl}${listings}delete-account/tenants`;
    },
    get updateTenancyPeriodUrl() {
      return `${baseUrl}${listings}update/tenancy`;
    },
    get updatePropertyDetails() {
      return `${baseUrl}${listings}update/property-details`;
    },
    get deletePropertyBedroom() {
      return `${baseUrl}${listings}delete/property-bedroom`;
    },
    get addBedrooms() {
      return `${baseUrl}${listings}add/property-bedroom`;
    },
    get updateBedroomIdentifier() {
      return `${baseUrl}${listings}update/bedroom-identifier`;
    },
    get sendBulkCreateAccountReminder() {
      return `${baseUrl}${listings}create-account/bulk-reminders`;
    },
    getListingDocumentsUrl(listingId) {
      return `${baseUrl}${listings}${listingId}/documents`;
    },
    uploadListingDocumentUrl(listingId) {
      return `${baseUrl}${listings}${listingId}/documents/upload`;
    },
    getListingDocumentViewUrl(listingId, documentId) {
      return `${baseUrl}${listings}${listingId}/documents/${documentId}/view-url`;
    },
    deleteListingDocumentUrl(listingId, documentId) {
      return `${baseUrl}${listings}${listingId}/documents/${documentId}`;
    },
    setListingDocumentShareUrl(listingId, documentId) {
      return `${baseUrl}${listings}${listingId}/documents/${documentId}/share`;
    },
    renameListingDocumentUrl(listingId, documentId) {
      return `${baseUrl}${listings}${listingId}/documents/${documentId}/rename`;
    },
    shareListingDocumentEmailUrl(listingId, documentId) {
      return `${baseUrl}${listings}${listingId}/documents/${documentId}/share-email`;
    }
  },
  tags: {
    get getListings() {
      return `${baseUrl}${tags}add-tag-listings`;
    },
    get addTag() {
      return `${baseUrl}${tags}add-tag`;
    },
    get editTag() {
      return `${baseUrl}${tags}edit-tag`;
    },
    get deleteTag() {
      return `${baseUrl}${tags}delete-tag`;
    },
    get getTags() {
      return `${baseUrl}${tags}all-tags`;
    },
    get getTagsListing() {
      return `${baseUrl}${tags}all-tags-listing`;
    }
  },
  propertyOwners: {
    get getListings() {
      return `${baseUrl}listings/all`;
    },
    get addPropertyOwner() {
      return `${baseUrl}property-owners`;
    },
    get editPropertyOwner() {
      return `${baseUrl}property-owners`;
    },
    get deletePropertyOwner() {
      return `${baseUrl}property-owners`;
    },
    get getPropertyOwners() {
      return `${baseUrl}property-owners`;
    }
  },
  announcement: {
    get addAnnouncementUrl() {
      return `${baseUrl}${announcements}add`;
    },
    get getLandlordAnnouncementListUrl() {
      return `${baseUrl}${announcements}all`;
    },
    get getTenantAnnouncementListUrl() {
      return `${baseUrl}${announcements}tenantAll`;
    }
  },
  tickets: {
    get sendLinkTicketCreation() {
      return `${baseUrl}${tickets}sendLinkTicketCreation`;
    },
    get getAllTicketsCountUrl() {
      return `${baseUrl}${tickets}counter`;
    },
    get getAllTickets() {
      return `${baseUrl}${tickets}all`;
    },
    get getPrimaryContacts() {
      return `${baseUrl}${tickets}primary-contacts`;
    },
    get getTradespersonListings() {
      return `${baseUrl}${tickets}tradesperson-listings`;
    },
    get getTenantTradespersons() {
      return `${baseUrl}${tickets}tenant-tradespersons`;
    },
    get getArchivedJobs() {
      return `${baseUrl}${tickets}archived/all`;
    },
    get addTicket() {
      return `${baseUrl}${tickets}add`;
    },
    createSubTask(masterId) {
      return `${baseUrl}${tickets}${masterId}/sub-task`;
    },
    getLinkableSubTickets(masterId) {
      return `${baseUrl}${tickets}${masterId}/linkable-sub-tickets`;
    },
    linkSubTicket(masterId) {
      return `${baseUrl}${tickets}${masterId}/link-sub`;
    },
    get addTicketExternal() {
      return `${baseUrl}${tickets}addExternal`;
    },
    get setTicketStatus() {
      return `${baseUrl}${tickets}maintanance`;
    },
    get uploadTicketImages() {
      return `${baseUrl}${tickets}add-images`;
    },
    get uploadCompletionMedia() {
      return `${baseUrl}${tickets}completion-upload`;
    },
    get deleteTicketImages() {
      return `${baseUrl}${tickets}delete-images`;
    },
    get setTicketPrivate() {
      return `${baseUrl}${tickets}ticketPrivate`;
    },
    deleteMessage(id) {
      return `${baseUrl}${tickets}deleteChat/${id}`;
    },
    getTicketDetails(ticketId) {
      return `${baseUrl}${tickets}details/${ticketId}`;
    },
    get assignTradesman() {
      return `${baseUrl}${tickets}assignTradesman`;
    },
    get reassignTradesman() {
      return `${baseUrl}${tickets}reassignTradesman`;
    },
    get bookJob() {
      return `${baseUrl}${tickets}book/job`;
    },
    get jobCompletion() {
      return `${baseUrl}${tickets}job-completion`;
    },
    get jobCompletionUndo() {
      return `${baseUrl}${tickets}job-completion-undo`;
    },
    get jobCompletionExternal() {
      return `${baseUrl}${tickets}job-completion-external`;
    },
    get addComment() {
      return `${baseUrl}${tickets}addChat`;
    },
    get addPrivateComment() {
      return `${baseUrl}${tickets}addChatPrivate`;
    },
    get editComment() {
      return `${baseUrl}${tickets}editChat`;
    },
    get ExportCsv() {
      return `${baseUrl}${tickets}export-csv`;
    },
    get rateTicket() {
      return `${baseUrl}${tickets}feedback`;
    },
    rejectJob(rejectionId) {
      return `${baseUrl}${tickets}deleteAssignmentt/${rejectionId}`;
    },
    mediaRequirment(ticketId) {
      return `${baseUrl}${tickets}completionMediaRequirment/${ticketId}`;
    },
    removeAssignedTradesman(assignmentId, ticketId, sendSMS) {
      return `${baseUrl}${tickets}deleteAssignment/${assignmentId}/${ticketId}/${sendSMS}`;
    },
    getComments(ticketId) {
      return `${baseUrl}${tickets}chatMessages/${ticketId}`;
    },
    getCommentsPrivate(ticketId) {
      return `${baseUrl}${tickets}chatMessagesPrivate/${ticketId}`;
    },
    assignedTradesmans(ticketId) {
      return `${baseUrl}${tickets}assignedTradesman/${ticketId}`;
    },
    closeTicket(ticketId, userId) {
      return `${baseUrl}${tickets}closeTicket/${ticketId}/${userId}`;
    },
    isClosed(ticketId) {
      return `${baseUrl}${tickets}isClosed/${ticketId}`;
    },
    deleteTicket(ticketId) {
      return `${baseUrl}${tickets}${ticketId}`;
    },
    extendDescription(ticketId) {
      return `${baseUrl}${tickets}extendDescription/${ticketId}`;
    },
    updateTicketDetails(ticketId) {
      return `${baseUrl}${tickets}${ticketId}`;
    },
    updatePrimaryContact(ticketId) {
      return `${baseUrl}${tickets}${ticketId}/primary-contact`;
    },
    updateTenantContact(ticketId) {
      return `${baseUrl}${tickets}${ticketId}/tenant-contact`;
    },
    setPriority(ticketId) {
      return `${baseUrl}${tickets}setPriority/${ticketId}`;
    },
    ticketDetails(ticketId) {
      return `${baseUrl}${tickets}ticketDetailsPDF/${ticketId}`;
    },
    updateTicketNotes(ticketId) {
      return `${baseUrl}${tickets}${ticketId}/notes`;
    },
    sendTicketEmail() {
      return `${baseUrl}${tickets}email`;
    },
    createTicketQuotes(ticketId) {
      return `${baseUrl}${tickets}quotes/${ticketId}`;
    },
    getTicketQuotes(ticketId) {
      return `${baseUrl}${tickets}quotes/${ticketId}`;
    },
    submitQuote(quoteId) {
      return `${baseUrl}${tickets}quotes/${quoteId}/submit`;
    },
    declineQuote(quoteId) {
      return `${baseUrl}${tickets}quotes/${quoteId}/decline`;
    },
    approveQuote(quoteId) {
      return `${baseUrl}${tickets}quotes/${quoteId}/approve`;
    },
    sendQuoteForApproval(quoteId) {
      return `${baseUrl}${tickets}quotes/${quoteId}/send-for-approval`;
    },
    cancelQuote(quoteId) {
      return `${baseUrl}${tickets}quotes/${quoteId}/cancel`;
    },
    resendQuoteRequest(quoteId) {
      return `${baseUrl}${tickets}quotes/${quoteId}/resend`;
    },
    approveQuotePublic(quoteId) {
      return `${baseUrl}${tickets}public/quotes/owner/${quoteId}/approve`;
    },
    declineQuotePublic(quoteId) {
      return `${baseUrl}${tickets}public/quotes/owner/${quoteId}/decline`;
    },
    getQuoteByToken(quoteToken) {
      return `${baseUrl}${tickets}public/quotes/${quoteToken}`;
    },
    submitQuotePublic(quoteToken) {
      return `${baseUrl}${tickets}public/quotes/${quoteToken}/submit`;
    },
    declineQuotePublicByTp(quoteToken) {
      return `${baseUrl}${tickets}public/quotes/${quoteToken}/decline`;
    },
    createLandlordQuote(ticketId) {
      return `${baseUrl}${tickets}quotes/${ticketId}/landlord-create`;
    },
    createTradespersonQuote(ticketId) {
      return `${baseUrl}${tickets}quotes/${ticketId}/tradesperson-create`;
    },
    editQuote(quoteId) {
      return `${baseUrl}${tickets}quotes/${quoteId}/edit`;
    }
  },
  tradesman: {
    get addTradesman() {
      return `${baseUrl}${trades}add`;
    },
    get updateTradesman() {
      return `${baseUrl}${trades}update`;
    },
    get resendTradesmanInvite() {
      return `${baseUrl}${trades}resendInvite`;
    },
    get viewAllTradesman() {
      return `${baseUrl}${trades}all`;
    },
    get viewAllTradesmanPaginated() {
      return `${baseUrl}${trades}all-paginated`;
    },
    get getLandlords() {
      return `${baseUrl}${trades}all-landlord`;
    },
    viewUnassignedTradesman(ticketId) {
      return `${baseUrl}${trades}assign/${ticketId}`;
    },
    checkTradesmanEmail(email) {
      return `${baseUrl}${trades}check/${email}`;
    },
    deleteTradesman(tradesmanId) {
      return `${baseUrl}${trades}delete/${tradesmanId}`;
    },
    getsingleTradesman(tradesmanId) {
      return `${baseUrl}${trades}/${tradesmanId}`;
    }
  },
  liaison: {
    get addAdminUser() {
      return `${baseUrl}liaison/addAdminUser`;
    },
    get viewAllLiaisons() {
      return `${baseUrl}liaison/all`;
    },
    getSingleLiaison(liaisonId) {
      return `${baseUrl}liaison/${liaisonId}`;
    },
    deleteLiaison(liaisonId) {
      return `${baseUrl}liaison/delete/${liaisonId}`;
    },
    updateLiaisonPassword(liaisonId) {
      return `${baseUrl}liaison/changePassword/${liaisonId}`;
    },
    updateLiaison(liaisonId) {
      return `${baseUrl}liaison/update/${liaisonId}`;
    },
    resendLiaisonInvitation(liaisonId) {
      return `${baseUrl}liaison/resendInvitation/${liaisonId}`;
    }
  },
  user: {
    get getLandlord() {
      return `${baseUrl}users/getLandlord`;
    },
    get checkInvitation() {
      return `${baseUrl}users/checkInvitation`;
    },
    get checkInvitationTradesperson() {
      return `${baseUrl}users/checkInvitationTradesperson`;
    },
    get getAccountCustomisationSettings() {
      return `${baseUrl}users/customSettings`;
    },
    get updatecustomAccountSettings() {
      return `${baseUrl}users/updateCustomSettings`;
    },
    get updateTicketingCustomSettings() {
      return `${baseUrl}users/updateTicketingCustomSettings`;
    },
    get getDetails() {
      return `${baseUrl}users/details`;
    },
    get validateTicketToken() {
      return `${baseUrl}users/validateTicketToken`;
    },
    get updateUserUrl() {
      return `${baseUrl}users/update/`;
    },
    get inviteLandlord() {
      return `${baseUrl}users/invite/landlord/`;
    },
    get unsubscribe() {
      return `${baseUrl}users/unsubscribe/invitation`;
    },
    get getAccountDetails() {
      return `${baseUrl}users/accountDetails`;
    },
    get getTicketingCustomSettings() {
      return `${baseUrl}users/ticketingCustomSettings`;
    },
    get getPushNotificationPreferences() {
      return `${baseUrl}users/push-notification-preferences`;
    },
    get updatePushNotificationPreferences() {
      return `${baseUrl}users/push-notification-preferences`;
    },
    get getSubscriptionDetails() {
      return `${baseUrl}users/subscriptionDetails`;
    },
    get updateContactDetails() {
      return `${baseUrl}users/updateContactDetails`;
    },
    getUserDetailsByEmail(email) {
      return `${baseUrl}users/get-details/${email}`;
    },
    updateProfileImage(email) {
      return `${baseUrl}users/updateProfileImage/${email}`;
    },
    updateUserDetails(email) {
      return `${baseUrl}users/updateUserDetails/${email}`;
    },
    get pushTokenRegister() {
      return `${baseUrl}users/push-token/register`;
    },
    get pushTokenRemove() {
      return `${baseUrl}users/push-token/remove`;
    },
    get onboardingGuideStatus() {
      return `${baseUrl}users/onboarding-guide/status`;
    },
    get onboardingGuideConsume() {
      return `${baseUrl}users/onboarding-guide/consume`;
    },
    get onboardingGuideContent() {
      return `${baseUrl}users/onboarding-guide/content`;
    },
    onboardingGuideStep(stepIndex) {
      return `${baseUrl}users/onboarding-guide/step/${stepIndex}`;
    },
    get onboardingGuideDismiss() {
      return `${baseUrl}users/onboarding-guide/dismiss`;
    }
  },
  subscription: {
    get createSubscription() {
      return `${baseUrl}subscription/create`;
    },
    get getSubscriptionDetails() {
      return `${baseUrl}subscription/details`;
    },

    get getSubscriptionHistory() {
      return `${baseUrl}subscription/history`;
    },
    getSubscriptionHistoryById(subscriptionId) {
      return `${baseUrl}subscription/history/${subscriptionId}`;
    },
    get getStatus() {
      return `${baseUrl}subscription/status`;
    },
    get createCustomerPortalSession() {
      return `${baseUrl}subscription/customer-portal`;
    }
  },
  messages: {
    get getMessages() {
      return `${baseUrl}messages/get-all`;
    },
    get getNotification() {
      return `${baseUrl}messages/get-all-notification`;
    },
    get markRead() {
      return `${baseUrl}messages/mark-read`;
    },
    get markReadNotifications() {
      return `${baseUrl}messages/explicit-read`;
    },
    get deleteNotifications() {
      return `${baseUrl}messages/notification/delete`;
    },
    markReadNotificationByOpen(id) {
      return `${baseUrl}messages/implicit-read/${id}`;
    },
    getShareDocumentViewUrl(notificationId, documentId) {
      return `${baseUrl}messages/notification/${notificationId}/document/${documentId}/view-url`;
    },
    get markUnread() {
      return `${baseUrl}messages/mark-unread`;
    },
    get markReadTicket() {
      return `${baseUrl}messages/mark-read-ticket`;
    },
    get deleteMesages() {
      return `${baseUrl}messages/delete-messages`;
    },
    get getUnreadCount() {
      return `${baseUrl}messages/unread-count`;
    }
  },
  quoteNotifications: {
    get getQuotes() {
      return `${baseUrl}quote-notifications/get-all`;
    },
    get markRead() {
      return `${baseUrl}quote-notifications/mark-read`;
    },
    get markUnread() {
      return `${baseUrl}quote-notifications/mark-unread`;
    },
    get markReadTicket() {
      return `${baseUrl}quote-notifications/mark-read-ticket`;
    },
    get delete() {
      return `${baseUrl}quote-notifications/delete`;
    }
  },
  checklist: {
    get getChecklist() {
      return `${baseUrl}${checklist}all`;
    },
    get addChecklistItem() {
      return `${baseUrl}${checklist}add-item`;
    },
    get addChecklistItemsTicket() {
      return `${baseUrl}${checklist}add-items-to-ticket`;
    },
    deleteChecklistItemFromTicket(itemId, ticketId) {
      return `${baseUrl}${checklist}ticket/${itemId}/${ticketId}`;
    },
    shareChecklistItemTicket(itemId, ticketId) {
      return `${baseUrl}${checklist}ticket-shared/${itemId}/${ticketId}`;
    },
    statusChecklistItemTicket(itemId, ticketId) {
      return `${baseUrl}${checklist}ticket-status/${itemId}/${ticketId}`;
    },
    get commentItemToTicket() {
      return `${baseUrl}${checklist}ticket-item-comment`;
    },
    deleteChecklistItem(id) {
      return `${baseUrl}${checklist}${id}`;
    },
    updateSharedStatus(id) {
      return `${baseUrl}${checklist}shared/${id}`;
    },
    updateDefaultStatus(id) {
      return `${baseUrl}${checklist}default/${id}`;
    },
    get reorderChecklist() {
      return `${baseUrl}${checklist}reorder`;
    }
  },
  compliance: {
    get getCompliances() {
      return `${baseUrl}compliance/all`;
    },
    getPropertyWithCompliances(propertyId) {
      return `${baseUrl}compliance/property/${propertyId}`;
    },
    get addCompliance() {
      return `${baseUrl}compliance`;
    },
    getComplianceById(id) {
      return `${baseUrl}compliance/${id}`;
    },
    updateCompliance(id) {
      return `${baseUrl}compliance/${id}`;
    },
    deleteCompliance(id) {
      return `${baseUrl}compliance/${id}`;
    },
    getAllCompliances() {
      return `${baseUrl}compliance/all/compliances`;
    },
    complianceSummary() {
      return `${baseUrl}compliance/all/summary`;
    },
    getComplianceHistory(id) {
      return `${baseUrl}compliance/${id}/history`;
    },
    complianceDocuments(id) {
      return `${baseUrl}compliance/${id}/documents`;
    },
    replaceComplianceDocument(id, documentId) {
      return `${baseUrl}compliance/${id}/documents/${documentId}/replace`;
    },
    moveComplianceDocumentToHistory(id, documentId) {
      return `${baseUrl}compliance/${id}/documents/${documentId}/move-to-history`;
    },
    deleteComplianceDocument(id, documentId) {
      return `${baseUrl}compliance/${id}/documents/${documentId}`;
    },
    complianceDocumentViewUrl(id, documentId) {
      return `${baseUrl}compliance/${id}/documents/${documentId}/view-url`;
    },
    get complianceTypes() {
      return `${baseUrl}compliance/types`;
    },
    complianceType(typeId) {
      return `${baseUrl}compliance/types/${typeId}`;
    },
    setComplianceShare(id) {
      return `${baseUrl}compliance/${id}/share`;
    },
    shareComplianceEmail(id) {
      return `${baseUrl}compliance/${id}/share-email`;
    }
  },
  category: {
    getCategory(page, limit) {
      return `${baseUrl}category?page=${page}&limit=${limit}`;
    },
    getCategoryExternal(page, limit) {
      return `${baseUrl}category/External?page=${page}&limit=${limit}`;
    }
  },
  support: {
    get supportEmail() {
      return `${baseUrl}${support}`;
    }
  },
  shortLinks: {
    resolveUrl(token) {
      return `${baseUrl}short-links/resolve/${token}`;
    }
  },
  hub: {
    get listFolders() { return `${baseUrl}hub/folders`; },
    get createFolder() { return `${baseUrl}hub/folders`; },
    renameFolderUrl(folderId) { return `${baseUrl}hub/folders/${folderId}`; },
    deleteFolderUrl(folderId) { return `${baseUrl}hub/folders/${folderId}`; },
    get listFiles() { return `${baseUrl}hub/files`; },
    get uploadFile() { return `${baseUrl}hub/files/upload`; },
    get generalPicker() { return `${baseUrl}hub/files/general/picker`; },
    viewUrlFor(fileId) { return `${baseUrl}hub/files/${fileId}/view-url`; },
    deleteFileUrl(fileId) { return `${baseUrl}hub/files/${fileId}`; },
    // Tenant-only: property documents and compliance records shared by the landlord.
    get sharedPropertyDocuments() { return `${baseUrl}hub/shared/property-documents`; },
    get sharedCompliance() { return `${baseUrl}hub/shared/compliance`; },
    sharedPropertyDocumentViewUrl(documentId) { return `${baseUrl}hub/shared/property-documents/${documentId}/view-url`; },
    sharedComplianceDocumentViewUrl(documentId) { return `${baseUrl}hub/shared/compliance-documents/${documentId}/view-url`; },
  },
  publicHub: {
    resolveFileToken(token) { return `${baseUrl}public/hub/file/${token}`; },
  },
  emailTemplates: {
    get list() { return `${baseUrl}email-templates/all`; },
    updateUrl(templateKey) { return `${baseUrl}email-templates/${templateKey}`; },
    get preview() { return `${baseUrl}email-templates/preview`; }
  }
};
